'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _projects = require('helpers/projects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectStatus = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectStatus, _Component);

  function ProjectStatus() {
    (0, _classCallCheck3.default)(this, ProjectStatus);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectStatus.__proto__ || (0, _getPrototypeOf2.default)(ProjectStatus)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectStatus, [{
    key: 'render',
    value: function render() {
      var status = this.props.status;

      var statusTexts = (0, _projects.getProjectStatusTexts)();

      return _react2.default.createElement(
        'span',
        { className: 'projectStatus ' + status },
        statusTexts[status] || status
      );
    }
  }]);
  return ProjectStatus;
}(_react.Component), _class.propTypes = {
  status: _propTypes2.default.string
}, _temp);
exports.default = ProjectStatus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/ProjectStatus/ProjectStatus.js
// module id = 516
// module chunks = 1